<template>
  <div class="wrapper height100">
    <div v-if="loading" class="d-flex align-center height100">
      <vue-loading
        loader="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
    <v-container v-else fluid class="height100">
      <v-form class="pt-5">
        <div>
        <p>{{ t('familyCreate.description.line1') }}</p>
        <br />
        <p>{{ t('familyCreate.description.line2') }}</p>
        <p>{{ t('familyCreate.description.line3') }}</p>
        <br />
        <p>{{ t('familyCreate.description.line4') }}</p>
        <br />
        </div>
        <div>
          <p class="body-2 blue-grey--text">{{ t('familyCreate.childId') }}</p>
          <v-text-field
            v-model="postFamilyRequest.childCode"
            outlined
            dense></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">{{ t('familyCreate.password') }}</p>
          <v-text-field
            v-model="postFamilyRequest.password"
            outlined
            dense
            type="password"></v-text-field>
        </div>

        <div>
          <p class="body-2 blue-grey--text">{{ t('familyCreate.parentType') }}</p>
          <v-select
            v-model="postFamilyRequest.parentType"
            :items="parentTypes"
            item-title="text"
            item-value="value" outlined
            dense
          ></v-select>
        </div>

        <div class="d-flex justify-center my-5">
          <v-btn
            @click="postFamily"
            :loading="btnLoading"
            color="primary"
            block>
            {{ t('familyCreate.submit') }}
          </v-btn>
        </div>

        <div>
          <v-btn @click="logout" color="primary" outlined block>
            {{ t('familyCreate.logout') }}
          </v-btn>
        </div>
      </v-form>
    </v-container>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { t } from '@/i18n';

import { familyModule } from '@/store/entityModules/family';
import { auth0Module } from '@/store/entityModules/auth0';

// model
import { PostFamilyRequest } from '@/model/Family';

import parentTypes from '@/service/parentTypes';

interface DataType {
  postFamilyRequest: PostFamilyRequest;
  btnLoading: boolean;
}

export default defineComponent({
  components: {
    'vue-loading': Loading,
  },

  data: () => ({
    loading: true,
    btnLoading: false,
    postFamilyRequest: {
      childCode: '',
      password: '',
      parentType: '',
    },
  }),

  computed: {
    parentTypes() {
      return parentTypes.map((item) => ({
        ...item,
        text: t(`settingFamily.parentType.${item.value}`, item.text),
      }));
    },
  },

  methods: {
    t,
    async postFamily() {
      try {
        this.btnLoading = true;
        const response = await familyModule.postFamily(this.postFamilyRequest);
        if (response) {
          this.$router.push('/home');
          this.btnLoading = false;
        }
      } catch (error) {
        this.btnLoading = false;
      }
    },
    logout() {
      auth0Module.logout();
    },
  },

  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  },
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top));
    margin-bottom: calc(env(safe-area-inset-bottom));
  }
}
</style>
